'use es6';

const isObject = obj => (typeof obj === 'object' || typeof obj === 'function') && obj !== null;
export const stringifyIfObject = value => isObject(value) ? JSON.stringify(value) : value;